import { clientWithLoader as client }  from '../base/ecommClient';
import endpoint from '../../features/endPoints/ecommEndpoints';

const saveAppointmentsClient = (body) => {
  let requestBody = mapRequest(body);
  return client.post(
    endpoint.saveAppointments(),
    requestBody,
    mapResponse,
    mapError
  );
};


//map body to request body as per API
const mapRequest = (body) => {
    return body;
};

//map response to object needed by React view
const mapResponse = (response) => {
  return response;
};

//map error to object needed by React view
const mapError = (error) => {
  return error;
};
 
export default saveAppointmentsClient;